<template>
  <div class="approval-container">
    <van-nav-bar title="开单期限变更审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="materialList">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">物料明细</span>
        </template>
        <material-list :details-list="materialList" />
      </van-collapse-item>
      <van-collapse-item name="catgList">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">品类明细</span>
        </template>
        <catg-list :details-list="catgList" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { getHeadData, materialDetailQuery, catgDetailQuery } from '@/api/coopDeliveryDueModifyHead'
import Bridge from '@/components/dsbridge'

export default {
  name: 'DeliveryDueModifyApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-list': () => import('./components/MaterialList.vue'),
    'catg-list': () => import('./components/CatgList.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      materialList: [],
      catgList: [],
      businessKey: this.$route.query.businessKey
    }
  },
  computed: {
    thisPage() {
      return this
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      const headResp = await getHeadData(this.businessKey)
      this.headInfo = headResp.data || {}
      const applyCode = this.getBusinessKey()
      const [materialResp, catgResp] = await Promise.all([
        materialDetailQuery({ applyCode }),
        catgDetailQuery({ applyCode })
      ])
      this.materialList = this.extractList(materialResp)
      this.catgList = this.extractList(catgResp)
    },
    extractList(response) {
      if (!response) return []
      const data = response.data !== undefined ? response.data : response
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.rows)) return data.rows
      return []
    },
    getBusinessKey() {
      return this.headInfo.applyCode || this.businessKey
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
